import { useState } from "react";
import { LANGUAGES, isLocale, setLocale, t, useLocale } from "./locale";

export default function LanguageSelect({ compact = false }: { compact?: boolean }) {
  const locale = useLocale();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  return <div className={compact ? "language-select language-select--compact" : "language-select"}>
    <label>
      <span>{t("Language")}</span>
      <select aria-label={t("Language")} value={locale} disabled={busy}
        onChange={async (event) => {
          const next = event.target.value;
          if (!isLocale(next)) return;
          setBusy(true);
          setError(false);
          try { await setLocale(next); } catch { setError(true); }
          finally { setBusy(false); }
        }}>
        {LANGUAGES.map((language) => <option key={language.code} value={language.code} lang={language.code}>{language.name}</option>)}
      </select>
    </label>
    {error && <span role="alert">{t("Could not load this language. Try again.")}</span>}
  </div>;
}
